<template>
    <div class="font-poppin">
        <div class="filter-header header-bgcolor">
            <div class="fs-14 font-weight-bold ml-4">Filters <span style="color:#ffba00 !important;">({{totalFilters}})</span></div>
            <div class="pointer">
                <!-- <el-tooltip class="item" effect="dark" content="Back" placement="top">
                    <span @click="closeFilters()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ArrowBgBlue.svg" alt="arrow">
                    </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Reset" placement="top">
                    <span @click="resetFilter()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ResetBgBlue.svg" alt="reset">
                    </span>
                </el-tooltip> -->
                <el-tooltip class="item" effect="dark" content="Close" placement="top">
                    <span @click="closeFilters()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                    </span>
                </el-tooltip>
            </div>
        </div>
        <div class="container filter-contents">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Sales Forecast Name</span>
                        <multiselect :loading="sales_forecast_loading"
                        label="name"
                         id="ajaxpr"
                        track-by="id"
                        @search-change="searchSalesForecast"
                        :limit="1"
                        :limit-text="limitSalesForecastName"
                        placeholder="Select Forecast Name"
                        class="digi-multiselect approval-manager filter-multiple mt-2"
                        :options="sales_forecast"
                        v-model="sales_forecast_name"
                        :multiple="true"
                        :searchable="true"
                        :internal-search="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="3000"
                        :max-height="200"
                        :show-no-results="true"
                        :hide-selected="false"
                        @remove="removeSalesForecastName">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName text-capitalize">{{ option.name.replace(/_/g, " ") }}</span>
                                    <span class="custom__remove pointer" @click="removeSalesForecastName(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <!--template slot="option" slot-scope="{ option }">
                                <span class="text-capitalize">{{ option.name.replace(/_/g, " ") }}</span>
                            </!--template-->
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfList" />
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Sales Forecat Names Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Territory</span>
                        <multiselect :limit="1" :limit-text="limitTerritory" placeholder="Select Territory" label="name" @search-change="searchTerritories" :loading="territories_loading" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="territory" :options="territories" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName text-capitalize">{{ option.name }}</span>
                                    <span class="custom__remove pointer" @click="removeTerritory(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="option" slot-scope="{ option }">
                                <span class="text-capitalize">{{ option.name.replace(/_/g, " ") }}</span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfTerritories" />
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Territories Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Product</span>
                        <multiselect :limit="1" :limit-text="limitProduct" v-model="product_id" label="name" @search-change="searchProducts" :loading="products_loading" placeholder="Select Product" class="digi-multiselect approval-manager filter-multiple mt-2" :options="products_options" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName text-capitalize">{{ option.name.replace(/_/g, " ")}}</span>
                                    <span class="custom__remove pointer" @click="removeProduct(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="option" slot-scope="{ option }">
                                <span class="text-capitalize">{{ option.name.replace(/_/g, " ") }}</span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfProducts" />
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Products Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Forecast Period</span>
                        <multiselect :limit="1" :limit-text="limitForecastPeriod" placeholder="Select Forecast Period" class="digi-multiselect approval-manager filter-multiple mt-2" :options="forecast_period_options" v-model="forecast_period" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName text-capitalize">{{ option.replace(/_/g, " ")}}</span>
                                    <span class="custom__remove pointer" @click="removeForecastPeriod(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="option" slot-scope="{ option }">
                                <span class="text-capitalize">{{ option.replace(/_/g, " ") }}</span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Forecast Periods Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Targeted Sale ({{currency}})</span>
                        <multiselect :limit="1" placeholder="Select Targeted Sale" class="digi-multiselect approval-manager filter-multiple mt-2" :options="target_sale_options" v-model="target_sale" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer" @click="removeTargetedSale(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Targeted Sales Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Actual Sale ({{currency}})</span>
                        <multiselect placeholder="Select Actual Sale" class="digi-multiselect approval-manager filter-multiple mt-2" :options="actual_sale_options" v-model="actual_sale" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer" @click="removeActualSale(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Actual Sales Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-filtercolor font-weight-bold filter-titles">Status</span>
                        <multiselect :limit="1" :limit-text="limitStatus" placeholder="Select Status" class="digi-multiselect approval-manager filter-multiple mt-2" :options="status_options" v-model="status" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName text-capitalize">{{ option.replace(/_/g, " ")}}</span>
                                    <span class="custom__remove pointer" @click="removeStatus(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="option" slot-scope="{ option }">
                                <span class="text-capitalize">{{ option.replace(/_/g, " ") }}</span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Status Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mt-10">
                    <div class="d-flex flex-wrap pb-2 mr-3" style="float: right !important;">
                        <button class="btn mt-2 ml-6 new-reset-button" @click="resetFilter()">Reset</button>
                        <button class="btn mt-2 ml-6 new-apply-button" @click="update()">Apply</button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event';
import salesforecast from "../mixins/salesforecast";
import settings from "../mixins/settings";
import deals from "../mixins/deals";
import { SweetModal } from 'sweet-modal-vue';
import { debounce } from 'lodash'
export default {
    props:['showfilterData'],
    mixins:[salesforecast,settings,deals],
    components:{
        SweetModal
    },
    data() {
        return {
            warning_msg: '',
            sales_forecast_name: [],
            forecast_period: [],
            forecast_period_options: ['fiscal_year','half_yearly','month', 'quarterly'],
            target_sale: "",
            target_sale_options: ['0-1000','1000-2000','2000-3000','3000-4000','4000-5000','5000-6000','6000-7000','7000-8000','8000-9000','9000-10000','10000-11000','11000-12000','12000-13000','13000-14000','14000-15000'],
            actual_sale: "",
            actual_sale_options: ['0-1000','1000-2000','2000-3000','3000-4000','4000-5000','5000-6000','6000-7000','7000-8000','8000-9000','9000-10000','10000-11000','11000-12000','12000-13000','13000-14000','14000-15000'],
            status: [],
            status_options: ['active','assigned','assign_target','completed','un_achieved',],
            sales_forecast: [],
            sales_forecast_count: 0,
            sales_forecast_loading:false,
            sales_forecast_scrollable :false,
            sales_forecast_visible: false,
            temp_sales_forecast: [],
            limit: 10,
            selected_dropdown: null,
            //products lazy loading
            products_count: 0,
            products_loading:false,
            products_scrollable :false,
            products_visible: false,
            product_id: [],
            temp_products: [],
            products_options: [],
            //territories lazy loading
            territories_count: 0,
            territories_loading:false,
            territories_scrollable :false,
            territories_visible: false,
            territory: [],
            temp_territories: [],
            territories: [],
            value_targeted_sale: 0,
            value_actual_sale: 0,
            currency:'',
        }
    },
    methods: {
        limitSalesForecastName(count) {
			return `+ ${count} more`
        },
        limitTerritory(count){
            return `+ ${count} more`
        },
        limitProduct(count){
            return `+ ${count} more`
        },
        limitForecastPeriod(count){
            return `+ ${count} more`
        },
        limitStatus(count){
            return `+ ${count} more`
        },
        closeFilters(){
            this.$emit('hideFilters')
        },
        async searchSalesForecastDebouncer(search){
            this.sales_forecast_loading = true
            let params = {
                key_name: 'sale_forecast_name',
                search_key: search
            }
            let response = await this.listSalesForeCast(params)
            this.sales_forecast = response.response
            this.sales_forecast = this.sales_forecast.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.sales_forecast.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });
            this.sales_forecast_count = response.response.length;
            this.sales_forecast_loading = false
            this.sales_forecast_scrollable = false
        },
        async reachedEndOfList(reached){
            this.sales_forecast_visible = reached
            if (reached) {
                if (this.sales_forecast_scrollable == false) {
                    this.sales_forecast_loading = true
                    let params = {
                        skip: this.sales_forecast_count,
                        limit: this.limit
                    }
                    let response = await this.listSalesForeCast(params)
                    this.temp_sales_forecast = response.response.length;
                    if (response.skip == this.sales_forecast_count) {
                        if (this.temp_sales_forecast > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.sales_forecast.push(el);
                            });
                            this.sales_forecast = this.sales_forecast.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.sales_forecast.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.sales_forecast_count += response.response.length;
                            this.sales_forecast_loading = false
                        } else {
                            this.sales_forecast_scrollable = true
                            this.sales_forecast_loading = false
                        }
                    }
                    this.sales_forecast_loading = false
                }
            }
        },
        //products lazy loading
        async searchProductsDebouncer(search_key) {
            this.search_key = search_key
            this.products_loading = true
            try {
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: this.search_key,
                    sort_value: 1,
                    sort_key: "name"
                };
                let response = await this.getProductsList(params)
                this.products_options = response.response;
                this.products_count = response.response.length;
                this.products_loading = false
            }
            catch(error) {
            }
        },
        async reachedEndOfProducts(reached) {
            this.products_visible = reached
            if (reached) {
                if (this.products_scrollable == false) {
                    this.products_loading = true
                    let response = await this.getProductsList({
                        skip: this.products_count,
                        limit: 10,
                        search_key: this.search_key,
                        sort_value: 1,
                        sort_key: "name"
                    })
                    this.temp_products = response.response.length;
                    if (response.skip == this.products_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.products_options.push(el);
                            });
                            this.products_options = this.products_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.products_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.products_count += response.response.length;
                            this.products_loading = false
                        } else {
                            this.products_scrollable = true
                            this.products_loading = false
                        }
                    }
                    this.products_loading = false
                }
            }
        },
        //territories lazy loading
        async searchTerritoriesDebouncer(search_key) {
            this.territories_loading = true
            try {
                let params = {
                    skip: 0,
                    limit: 10
                };
                let response = await this.getTerritoryList(params)
                this.territories = response.response;
                this.territories_count = response.response.length;
                this.territories_loading = false
            }
            catch(error) {
            }
        },
        async reachedEndOfTerritories(reached) {
            this.territories_visible = reached
            if (reached) {
                if (this.territories_scrollable == false) {
                    this.territories_loading = true
                    let response = await this.getTerritoryList({
                        skip: this.territories_count,
                        limit: 10
                    })
                    this.temp_territories = response.response.length;
                    if (response.skip == this.territories_count) {
                        if (this.temp_territories > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.territories.push(el);
                            });
                            this.territories = this.territories.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.territories.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.territories_count += response.response.length;
                            this.territories_loading = false
                        } else {
                            this.territories_scrollable = true
                            this.territories_loading = false
                        }
                    }
                    this.territories_loading = false
                }
            }
        },
        removeSalesForecastName(option){
            this.sales_forecast_name.forEach((el,index)=>{
                if(el.id == option.id){
                    this.sales_forecast_name.splice(index,1)
                }
            })
        },
        removeTerritory(option){
            this.territory.forEach((el,index)=>{
                if(el.id == option.id){
                    this.territory.splice(index,1)
                }
            })
        },
        removeStatus(option){
            this.status.forEach((el,index)=>{
                if(el == option){
                    this.status.splice(index,1)
                }
            })
        },
        removeForecastPeriod(option){
            this.forecast_period.forEach((el,index)=>{
                if(el == option){
                    this.forecast_period.splice(index,1)
                }
            })
        },
        removeTargetedSale(option){
            this.target_sale = ""
            this.value_targeted_sale = 0
        },
        removeActualSale(option){
            this.actual_sale = ""
            this.value_actual_sale = 0
        },
        removeProduct(option){
            this.product_id.forEach((el,index)=>{
                if(el.id == option.id){
                    this.product_id.splice(index,1)
                }
            })
        },
        update(){
            this.sales_forecast_count = 0
            this.sales_forecast_loading = false
            this.sales_forecast_scrollable = false
            this.sales_forecast_visible = false
            this.territories_count = 0
            this.territories_loading = false
            this.territories_scrollable = false
            this.temp_territories = []
            this.territories_visible = false
            this.products_loading = false
            this.temp_products = []
            this.products_count = 0
            this.products_scrollable = false
            this.products_visible = false
            let temp_sales_forecast_name = [...new Set(this.sales_forecast_name.map(x =>x.name))]
            let temp_territory_name = [...new Set(this.territory.map(x =>x.name))]
            let temp_product_name = [...new Set(this.product_id.map(x =>x.id))]
            let temp_status = []
            this.status.forEach(x => {
                temp_status.push(x)
            })
            temp_status = temp_status.map(function(item) { return item == 'assign_target' ? 'un_assigned' : item; });
            temp_status = temp_status.map(function(item) { return item == 'need_to_assign' ? 'un_assigned' : item; });
            let params = {
                sale_forecast_name: this.sales_forecast_name,
                product_id: this.product_id,
                territory: this.territory,
                forecast_period: this.forecast_period,
                status: this.status,
                targeted_sale: this.target_sale,
                actual_sale: this.actual_sale
            }
            let params1 = {
                sale_forecast_name: temp_sales_forecast_name,
                product_id: temp_product_name,
                territory: temp_territory_name,
                forecast_period: this.forecast_period,
                status: temp_status,
                targeted_sale: this.target_sale,
                actual_sale: this.actual_sale
            }
            let newData = {
                value:params,
                value1:params1
            }
            this.$emit('UpdateByFilter',newData)
        },
        resetFilter(){
            if(this.totalFilters > 0){
                this.sales_forecast_name = []
                this.territory = []
                this.forecast_period = []
                this.status = []
                this.product_id = []
                this.target_sale = ""
                this.actual_sale = ""
                this.update()
            }
        },
    },
    async mounted(){
        this.currency = this.loggedInUser.currency.symbol;
        EventBus.$on('removechip',params=>{
            if(params.key == 'sales_forecast_name'){
                this.removeSalesForecastName(params.value)
                this.update()
            }else if(params.key == 'territory'){
                this.removeTerritory(params.value)
                this.update()
            }else if(params.key == 'product_id'){
                this.removeProduct(params.value)
                this.update()
            }else if(params.key == 'forecast_period'){
                this.removeForecastPeriod(params.value)
                this.update()
            }else if(params.key == 'targeted_sale'){
                this.removeTargetedSale(params.value)
                this.update()
            }else if(params.key == 'actual_sale'){
                this.removeActualSale(params.value)
                this.update()
            }else if(params.key == 'status'){
                this.removeStatus(params.value)
                this.update()
            }
        })
        EventBus.$on('removeAllchip',() => {
            this.resetFilter()
        })
        if(this.loggedInUser.user_role == 'team_lead'){
            this.status_options = ['active','assigned','completed','un_achieved','need_to_assign']
        }
        if(this.loggedInUser.user_role == 'sales_person'){
            this.status_options = ['active','completed','un_achieved']
        }


    },
    created(){
        this.searchSalesForecast = debounce(this.searchSalesForecastDebouncer, 500)
        this.searchTerritories = debounce(this.searchTerritoriesDebouncer, 500)
        this.searchProducts = debounce(this.searchProductsDebouncer, 500)
    },
    destroyed(){
        EventBus.$off('removechip')
        EventBus.$off('removeAllchip')
    },
    computed:{
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        totalFilters(){
            if(this.target_sale){
                this.value_targeted_sale = 1
            }
            else{
                this.value_targeted_sale = 0
            }
            if(this.actual_sale){
                this.value_actual_sale = 1
            }
            else{
                this.value_actual_sale = 0
            }
            return this.sales_forecast_name.length + this.territory.length + this.status.length + this.product_id.length + this.forecast_period.length + this.value_targeted_sale + this.value_actual_sale
        }
    }
}
</script>

<style scoped>
    .header-bgcolor {
        background-color: #00448b !important;
    }
    .filter-titles {
        color: #00448b;
    }
    .filter-contents {
        max-height: 500px !important;
        overflow-x: auto !important;
        overflow-y: auto !important;
    }
    .text-filtercolor {
        color: #00448b;
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/FilterData.vue